import { useState } from "react";
const useSearch = (config) => {
    const { items, fields } = config;
    const [query, setQuery] = useState('');
    function getField(field, item) {
        if (typeof field === "function")
            return field(item).toLowerCase();
        return item[field].toLowerCase();
    }
    const filterItems = () => {
        const text = query.trim().toLowerCase();
        let data = items;
        if (!text)
            return data;
        return data.filter((item) => {
            let concatFields = '';
            for (const field of fields) {
                concatFields += getField(field, item);
            }
            return concatFields.includes(text);
        });
    };
    return {
        filteredData: filterItems(),
        onChangeSearchQuery: setQuery,
        searchQuery: query
    };
};
export default useSearch;
